/**
 * Advanced Search Config Adapter for Grades
 * Transforms Grade Field Registry into Advanced Search field configurations
 */

import { FieldConfig } from '../../../components/TableSearch/types';
import { GRADE_FIELDS_REGISTRY } from '../fields';
import { BaseFieldDefinition } from '../../../shared/types/fieldRegistry';
import { Grade } from '../../../services/api/domains/grades/types';

/**
 * Convert a field definition to Advanced Search field config
 * @param field - Field definition from registry
 * @returns FieldConfig for Advanced Search
 */
function toSearchFieldConfig(
  field: BaseFieldDefinition<Grade>
): FieldConfig | FieldConfig[] {
  // Handle boolean fields - convert to selection
  const dataType =
    field.dataType === 'boolean'
      ? 'selection'
      : field.dataType === 'object'
        ? 'string'
        : (field.dataType as 'string' | 'number' | 'date' | 'selection');

  return {
    key: field.key as string,
    label: field.label,
    dataType,
    options: field.selectionOptions,
  };
}

/**
 * Convert Field Registry to Advanced Search configuration
 * @returns Array of FieldConfig for Advanced Search
 */
export function toAdvancedSearchConfig(): FieldConfig[] {
  const searchFields = GRADE_FIELDS_REGISTRY.filter(f => f.isSearchable);
  const configs: FieldConfig[] = [];

  searchFields.forEach(field => {
    const config = toSearchFieldConfig(field);
    if (Array.isArray(config)) {
      configs.push(...config);
    } else {
      configs.push(config);
    }
  });

  return configs;
}

/**
 * Get searchable field keys for filtering
 */
export function getSearchableFieldKeys(): string[] {
  return GRADE_FIELDS_REGISTRY.filter(f => f.isSearchable).map(
    f => f.key as string
  );
}
